import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Box, Grid } from '@yonderland/andes-react';
import { useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeGetProductDefaults, makeGetSelectedColorId, makeGetSelectedSku, } from '../../../redux/product/selectors/ProductSelector';
import { productPreviewActions } from '../../../redux/productPreview/actions/ProductPreviewActions.creators';
import { makeGetShowImageTouchZoomHint } from '../../../redux/productPreview/selectors/ProductPreviewSelectors';
import { LabelsOverlayAlpha } from '../../common/labels-overlay/LabelsOverlayAlpha';
import ProductPreview from '../product-preview/ProductPreview';
import { PlayVideoButton } from './PlayVideoButton';
import { ProductMediaWishListButton } from './ProductMediaWishListButton';
import { useProductMedia } from './useProductMedia';
export const ProductMediaSlider = () => {
    const { isShopLanding } = useAemConfig();
    const { labelsConfig, mediaCollection } = useProductMedia();
    const selectedColorId = useSelector(makeGetSelectedColorId());
    const showImageTouchZoomHint = useSelector(makeGetShowImageTouchZoomHint());
    const { productCode, productId } = useSelector(makeGetProductDefaults());
    const selectedSku = useSelector(makeGetSelectedSku());
    const dispatch = useDispatch();
    const productPreviewRef = useRef(null);
    const wishListProduct = {
        colorId: selectedColorId,
        productCode: productCode,
        productId: parseInt(productId, 10),
        sku: selectedSku,
    };
    const handleImageTouchZoom = () => {
        dispatch(productPreviewActions.disableImageTouchZoomHint());
    };
    const collectionContainsVideos = useMemo(() => mediaCollection.some(m => m.isVideo), [mediaCollection]);
    const handlePlayVideo = (e) => {
        const firstVideoIndex = mediaCollection.findIndex(m => m.isVideo);
        if (firstVideoIndex !== -1 && productPreviewRef.current) {
            productPreviewRef.current.openLightboxAtIndex(firstVideoIndex, e);
        }
    };
    return (_jsxs(Grid, { testId: "product_slider", columns: "stack", gap: 0, children: [_jsx(ProductPreview, { innerRef: productPreviewRef, selectedColorId: selectedColorId, productId: productId, showImageTouchZoomHint: showImageTouchZoomHint, onImageTouchZoom: handleImageTouchZoom, showLabels: false }), _jsx(Grid.Cell, { display: "flex", justify: "start", align: "end", children: _jsx(Box, { paddingBlockEnd: "14", flex: { grow: 0 }, children: _jsx(LabelsOverlayAlpha, Object.assign({}, labelsConfig, { testId: "product_slider_image_overlay" })) }) }), !isShopLanding && (_jsx(Grid.Cell, { display: "flex", justify: "end", align: "start", children: _jsx(Box, { paddingBlockStart: "5", paddingInlineEnd: "5", children: _jsx(ProductMediaWishListButton, { wishListProduct: wishListProduct }) }) })), collectionContainsVideos && (_jsx(Grid.Cell, { display: "flex", justify: "end", align: "end", children: _jsx(Box, { paddingBlockEnd: "14", paddingInlineEnd: "5", children: _jsx(PlayVideoButton, { onClick: handlePlayVideo, size: "sm" }) }) }))] }));
};
